import { httpGet, httpPatch, httpPost } from "@/src/api/http";
import type { GetRes, PatchRes, PostRes, Req } from "@/src/api/types";

export const LoginType = Object.freeze({
    BASIC_AUTHENTICATION: "basic_authentication",
    FIREBASE_SSO: "firebase_sso",
});

export function login(username: string, password: string) {
    return httpPost<PostRes<"login/">>(`login/`, { username, password });
}

export function samlLogin(uid: string, idToken?: string) {
    return httpPost<PostRes<"saml/login/">>(`saml/login/`, { uid, id_token: idToken });
}

export function logout() {
    return httpGet<GetRes<"logout/">>(`logout/`);
}

/** Resolves to the Django user id, or null when there is no session. */
export function getCurrentUser() {
    return httpGet<GetRes<"user/">>(`user/`);
}

export function requestPasswordReset(email: string) {
    return httpPost<void>(`user/reset_password/`, { email } satisfies Req<"user/reset_password/", "post">);
}

export function getUserPreferences() {
    return httpGet<GetRes<"user/preferences/">>(`user/preferences/`);
}

export function updateUserPreference(preference: string, value: unknown) {
    return httpPatch<PatchRes<"user/preferences/">>(`user/preferences/`, { preference, value });
}

export function getGlobalPermissions() {
    return httpGet<GetRes<"permissions/">>(`permissions/`);
}
